var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.95 10.775a1 1 0 0 1 1-1h15.003a1 1 0 0 1 0 2H32.95a1 1 0 0 1-1-1M15.309 16.563a1 1 0 0 1 1-1h46.838a1 1 0 1 1 0 2H16.31a1 1 0 0 1-1-1M29.453 30.745a1 1 0 0 1 1 1v4.365a1 1 0 1 1-2 0v-4.365a1 1 0 0 1 1-1M30.453 42.509a1 1 0 1 0-2 0v17.687a1 1 0 1 0 2 0zM39.35 30.745a1 1 0 0 1 1 1v4.365a1 1 0 1 1-2 0v-4.365a1 1 0 0 1 1-1M40.35 42.509a1 1 0 0 0-2 0v17.687a1 1 0 1 0 2 0zM49.248 30.745a1 1 0 0 1 1 1v4.365a1 1 0 1 1-2 0v-4.365a1 1 0 0 1 1-1M50.248 42.509a1 1 0 1 0-2 0v17.687a1 1 0 1 0 2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.26 21.617a1 1 0 0 0-1 1v46.546a1 1 0 0 0 1 1h37.48a1 1 0 0 0 1-1V22.617a1 1 0 0 0-1-1zm1 46.546V23.617h35.48v44.546z",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;